<template>
  <header>
    <nav class="navbar navbar-expand-md navbar-light">
      <div class="container-fluid align-items-sm-center">
        <router-link to="/Home" class="navbar-brand">
          <img :src="$t('Header.BrandLogo')" alt="Brand Logo" class="img-fluid" />
        </router-link>

        <button
          class="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbar-Nav"
          @click="toggleCollapse"
          aria-controls="navbar-Nav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
			<img src="https://snippcheck.blob.core.windows.net/files/WK_Kellogg_Free_Beach_Towel_2007813/images/hamburger_icon.png" alt="hamburger-icon" />
		</button>

        <div :class="{ show: isCollapsed }" class="collapse navbar-collapse justify-content-end my-md-2" id="navbar-Nav">
          <ul class="navbar-nav mr-auto">
            <li class="nav-item">
              <router-link to="/Home" class="nav-link text-uppercase">
                {{ $t('Header.HomeTab') }}
              </router-link>
            </li>
            <li class="nav-item ml-md-2">
              <router-link to="/Upload" class="nav-link text-uppercase">
                {{ $t('Header.UploadTab') }}
              </router-link>
            </li>
			<li class="nav-item ml-md-2">
              <router-link to="/ParticipatingProducts" class="nav-link text-uppercase">
                {{ $t('Header.ProductTab') }}
              </router-link>
            </li>
            <li class="nav-item ml-md-2">
              <router-link to="/Support" class="nav-link text-uppercase">
                {{ $t('Header.SupportTab') }}
              </router-link>
            </li>
          </ul>
        </div>

        <div class="langtoggle">
          <button @click="changeLanguage('en')" :class="{ active: currentLang === 'en' }">English</button> | 
          <button @click="changeLanguage('fr')" :class="{ active: currentLang === 'fr' }">Français</button>
        </div>
      </div>
    </nav>
  </header>

  <banner></banner>
</template>


<script>
import banner from '../UI/Banner.vue';
import { useI18n } from 'vue-i18n';
import { ref, watch, onMounted } from 'vue';
import { loadLocaleMessages } from '@/main.js';

export default {
  components: { banner },
  setup() {
    const { locale, t } = useI18n();
    const currentLang = ref(locale.value);
    const isCollapsed = ref(false); // ✅ Define state for toggle

    const toggleCollapse = () => {
      isCollapsed.value = !isCollapsed.value;
    };

    const closeMenu = () => {
      isCollapsed.value = false;
    };

    const changeLanguage = async (lang) => {
  if (currentLang.value === lang) return;

  const hostname = window.location.hostname;
  const isLocal = hostname === "localhost";
  const isStaging = hostname.includes("staging");

  if (isLocal) {
    // Local: Change language dynamically
    await loadLocaleMessages(lang);
    locale.value = lang;
    localStorage.setItem("locale", lang);
    currentLang.value = lang;
    injectCookieScript(lang);
    injectGTM();
  } else {
    // Staging & Production: Redirect to language-specific domains
    const currentPath = window.location.pathname;
    const currentQuery = window.location.search;

    const langBaseUrls = {
      en: isStaging ? "http://staging-freebeachtowel.snipp.us" : "https://www.freebeachtowel.ca",
      es: isStaging ? "http://staging-serviettedeplagegratuite.snipp.us" : "https://www.serviettedeplagegratuite.ca",
    };

    const targetBase = langBaseUrls[lang] || "/";
    const targetUrl = `${targetBase}${currentPath}${currentQuery}`;

    window.location.href = targetUrl;
  }
};


    watch(locale, (newLocale) => {
      currentLang.value = newLocale;
    });

    onMounted(() => {
      injectGTM();
      injectCookieScript(currentLang.value);
    });

    const injectGTM = () => {
      const gtmId = t('gtmId');
      if (!gtmId) return;

      document.querySelectorAll("[data-gtm]").forEach(el => el.remove());

      const script = document.createElement("script");
      script.setAttribute("data-gtm", gtmId);
      script.innerHTML = `
        (function (w, d, s, l, i) {
          w[l] = w[l] || []; w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
          var f = d.getElementsByTagName(s)[0],
              j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; 
          j.async = true; j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl; 
          f.parentNode.insertBefore(j, f);
        })(window, document, 'script', 'dataLayer', '${gtmId}');
      `;
      document.head.appendChild(script);

      const noscript = document.createElement("noscript");
      noscript.setAttribute("data-gtm", gtmId);
      noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${gtmId}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
      document.body.prepend(noscript);
    };

    const injectCookieScript = async (lang) => {
  try {
    const response = await fetch(`/locales/${lang}.json`);
    if (!response.ok) throw new Error(`Failed to load locale: ${lang}`);

    const data = await response.json();
    const cookieScript = data?.Header?.cookieScript;
    if (!cookieScript) return;

    // Remove old scripts
    document.querySelectorAll("[data-cookie-script]").forEach(el => el.remove());

    // Parse HTML and inject scripts properly
    const temp = document.createElement("div");
    temp.innerHTML = cookieScript;

    Array.from(temp.querySelectorAll("script, link")).forEach(tag => {
      const newTag = document.createElement(tag.tagName.toLowerCase());

      // Copy all attributes
      Array.from(tag.attributes).forEach(attr => {
        newTag.setAttribute(attr.name, attr.value);
      });

      // Copy inline script content
      if (tag.textContent) newTag.textContent = tag.textContent;

      newTag.setAttribute("data-cookie-script", lang);
      document.head.appendChild(newTag);
    });

  } catch (error) {
    console.error("CookieScript injection failed:", error);
  }
};


    return { currentLang, changeLanguage, isCollapsed, toggleCollapse, closeMenu };
  },
};
</script>
